<template>
  <div>
    <div v-if="mobile && !hideCancel" class="flex items-center justify-end py-1">
      <span class="px-2 rounded-full bg-i4m-grey pressable" @click="$emit('cancel')">Chiudi</span>
    </div>
    <div v-if="step === 1">
      <label for="instrument-type" class="font-bold">Che tipo di strumento vuoi assicurare?</label>
      <a-input-search
        class="w-full mt-4 mb-12 add-item-widget"
        placeholder="Digita il tipo.."
        id="instrument-type"
        @change="filterItems"
      />
      <div class="grid grid-cols-2 gap-4 search-results-panel md:grid-cols-3 md:overflow-y-auto">
        <div
          v-if="searchingItems"
          class="flex flex-col items-center justify-center p-4 border rounded-md cursor-pointer group hover:border-i4m-orange "
        >
          <div class="opacity-25">
            <vue-loaders name="square-spin" color="#ed8936" scale=".5"></vue-loaders>
          </div>
        </div>

        <div
          v-for="item in itemsToShow"
          :key="item.id"
          class="flex flex-col items-center justify-center p-4 transition duration-200 ease-out bg-white border rounded-md cursor-pointer group border-i4m-grey-input hover:border-i4m-orange"
          :style="{
            opacity: selectedItem && selectedItem != item.id ? 0.2 : 1,
            pointerEvents: selectedItem && selectedItem != item.id ? 'none' : 'all'
          }"
          @click="selectItem(item.id)"
        >
          <div v-if="selectingItem && selectedItem === item.id" class="opacity-25">
            <vue-loaders name="square-spin" color="#ed8936" scale=".5"></vue-loaders>
          </div>

          <svgicon v-else :name="`instruments/${item.icon}`" width="48" height="48"></svgicon>

          <span
            class="w-full mt-3 mb-3 border-t border-solid group-hover:border-white border-i4m-grey-input"
          ></span>
          <span class="text-center text-md group-hover:text-i4m-orange">{{ item.name }}</span>
        </div>
      </div>

      <div class="flex items-center justify-end mt-10" v-if="!hideCancel">
        <a-button @click="$emit('cancel')">
          Annulla
        </a-button>
      </div>
    </div>

    <div v-if="step > 1">
      <label for="instrument-type" class="font-bold">Stai aggiungendo al carrello:</label>
      <div class="mb-10 text-2xl font-semibold">{{ selectedItemLabel }}</div>
    </div>

    <div v-if="step === 2">
      <div class="">
        <instrument-info-form :item="selectedItemFull" ref="instrumentInfoForm" />

        <div class="flex items-center justify-end">
          <a-button type="primary" @click="checkInstrumentForm" :loading="adding">
            Prosegui
          </a-button>
        </div>
      </div>
    </div>

    <div v-if="step === 3">
      <survey-form
        ref="surveyForm"
        :survey="survey"
        @change="(field, value) => $set(survey, field, value)"
      />

      <div class="flex items-center justify-end">
        <a-button type="primary" @click="addToCart" :loading="adding">
          Aggiungi al preventivo
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import matchSorter from 'match-sorter';
import api from '@/api';
import Vue from 'vue';

export default {
  name: 'AddItemWidget',
  props: ['stopAfterStep', 'onAddedInstrument', 'onInstrumentFormCompleted', 'hideCancel'],
  data: function() {
    return {
      filteredItems: [],
      filtering: false,
      selectedItem: null,
      selectingItem: false,
      step: 1,
      instrumentInfo: null,
      survey: {},
      adding: false
    };
  },

  computed: {
    ...mapState(['items', 'searchingItems']),
    itemsToShow() {
      if (this.filtering) {
        return this.filteredItems;
      } else {
        return this.items;
      }
    },

    mobile() {
      return this.$mq.resize && this.$mq.below('768px');
    },

    selectedItemLabel() {
      if (!this.selectedItem) return null;

      return this.items.find(i => i.id === this.selectedItem).name;
    },

    selectedItemFull() {
      if (!this.selectedItem) return null;

      console.log(
        'this.items.find(i => i.id === this.selectedItem);',
        this.items.find(i => i.id === this.selectedItem)
      );

      return this.items.find(i => i.id === this.selectedItem);
    }
  },

  methods: {
    reset() {
      this.filteredItems = [];
      this.filtering = false;
      this.selectedItem = null;
      this.selectingItem = false;
      this.step = 1;
      this.instrumentInfo = null;
      this.survey = {};
      this.adding = false;
    },

    async checkInstrumentForm() {
      const values = await this.$refs.instrumentInfoForm.getValues().catch(err => {
        console.log(err);
        return null;
      });

      if (!values) return;

      this.instrumentInfo = values;
      this.survey[1] = values['survey-1'];
      delete this.instrumentInfo['survey-1'];

      if (this.stopAfterStep == 2) {
        this.adding = true;
        await this.onInstrumentFormCompleted(this.selectedItem, this.instrumentInfo, this.survey);
        this.adding = false;

        return this.$emit('added', {
          itemId: this.selectedItem,
          instrumentInfo: this.instrumentInfo,
          survey: this.survey
        });
      }

      this.step++;
    },

    async addToCart() {
      const values = await this.$refs.surveyForm.getValues().catch(err => {
        console.log(err);
        return null;
      });

      if (!values) return;

      this.survey = { ...this.survey, ...values };

      this.add();
    },

    async add() {
      let payload = { ...this.instrumentInfo };

      payload.survey = { ...this.survey };

      this.adding = true;
      const resp = await api.addOrderItem(this.selectedItem, payload).catch(err => {
        this.$notification.error({
          message: "C'è stato un errore nell'inserimento dello strumento nel carrello. Contattaci!",
          duration: 4
        });

        return null;
      });

      this.adding = false;

      if (!resp) return;

      await this.$store.dispatch('getOrder', true);
      this.$emit('added');
    },

    async selectItem(id) {
      this.selectingItem = true;
      this.selectedItem = id;

      if (this.onAddedInstrument) {
        await this.onAddedInstrument(id);

        if (this.stopAfterStep == 1) {
          this.$emit('added', {
            itemId: id
          });
        }
      } else {
        setTimeout(async () => {
          this.selectingItem = false;

          if (this.stopAfterStep == 1) {
            this.$emit('added', {
              itemId: id
            });

            await this.$store.dispatch('getOrder', true);
          }

          this.step = 2;
        }, 1200);
      }
    },

    filterItems(e) {
      const value = e.currentTarget.value;
      if (!value || value.length === 0) {
        this.filtering = false;
        return;
      }

      this.filtering = true;

      const res = matchSorter(this.items, value, { keys: ['name'] });
      this.filteredItems = res;
    }
  }
};
</script>

<style lang="scss">
@import '@/variables.scss';

.anticon.anticon-loading {
  color: #ed8936;
}

.search-results-panel {
  @media #{$md} {
    max-height: 420px;
  }
}
</style>
